module.exports = __webpack_public_path__ + "static/media/peter-kasprzyk-111462-unsplash.71f6274b.jpg";